import React from 'react';
import RatingRow from '../RatingRow';
import * as styles from './RatingFirms.scss';
import RatingHeader from '../RatingHeader';
import RatingRowMobile from '../RatingRowMobile';

const RatingFirms = ({
  firms, totalFirmsCount, selectedRow, isMobile,
}) => {
  const RatingRowComponent = isMobile ? RatingRowMobile : RatingRow;
  return (
    <div className={styles.ratingBlock}>
      <RatingHeader count={totalFirmsCount} isMobile={isMobile} />
      <div className={styles.firms}>
        { firms.map(row => (
          <RatingRowComponent
            key={row.position}
            selectedRow={selectedRow}
            row={row}
          />
        ))}
      </div>
    </div>
  );
};

export default RatingFirms;
